import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useUnmount from 'common/hooks/useUnmount';

import { I18nNameSpaces } from 'common/services/i18n';
import { PasswordResetForm } from 'common/forms';
import { ResetPasswordFormValues } from 'common/models/User';
import { Result } from 'common/components';

import { AuthPageDescription } from '../../../../components';
import {
  requestPasswordRecoveryActions,
  selectForgottenPasswordSuccess,
  resetPasswordRecoveryAction,
} from '../../ducks';

function ForgottenPasswordRequestFeature() {
  const { t } = useTranslation(I18nNameSpaces.Auth);
  const dispatch = useDispatch();
  const success = useSelector(selectForgottenPasswordSuccess);
  const forgottenPassPage = 'forgottenPassword.request.page';

  useUnmount(() => {
    dispatch(resetPasswordRecoveryAction());
  });

  function handlePasswordResetSubmit({ email }: ResetPasswordFormValues) {
    dispatch(requestPasswordRecoveryActions.request(email));
  }

  return (
    <Row justify="center">
      <Col xs={24} md={8}>
        {success ? (
          <Result
            status="success"
            title={t(`${forgottenPassPage}.successTitle`)}
            subTitle={t(`${forgottenPassPage}.successSubtitle`)}
          />
        ) : (
          <>
            <AuthPageDescription
              title={t(`${forgottenPassPage}.title`)}
              description={t(`${forgottenPassPage}.description`)}
            />
            <PasswordResetForm onSubmit={handlePasswordResetSubmit} />
          </>
        )}
      </Col>
    </Row>
  );
}

export default ForgottenPasswordRequestFeature;
